<div class="user-settings-wrapper">
  <app-cr-back-button [goBack]="true" [fontSize]="'LARGE'">
    {{ 'COMMON.REDIRECT.BACK' | translate }}
  </app-cr-back-button>

  <nz-tabset
    *ngIf="myself && currentLang"
    [nzSelectedIndex]="selectedTabIndex"
    (nzSelectedIndexChange)="onTabChange($event)">
    <nz-tab [nzTitle]="'USER_SETTINGS.USER_SETTINGS_DETAILS' | translate">
      <ng-template nz-tab>
        <app-user-settings-details [myself]="myself" [currentLang]="currentLang"></app-user-settings-details>
      </ng-template>
    </nz-tab>

    <nz-tab [nzTitle]="'USER_SETTINGS.USER_SETTINGS_TRANSACTIONS' | translate" [nzDisabled]="!showPurchaseList">
      <ng-template nz-tab>
        <app-user-settings-transactions [myself]="myself" [currentLang]="currentLang"></app-user-settings-transactions>
      </ng-template>
    </nz-tab>

    <nz-tab [nzTitle]="'USER_SETTINGS.USER_SETTINGS_GDPR' | translate" [nzDisabled]="!showConsents">
      <ng-template nz-tab>
        <app-user-settings-consents [myself]="myself" [currentLang]="currentLang"></app-user-settings-consents>
        <div class="components-separator" [attr.aria-hidden]="true"></div>
        <app-user-settings-list-of-requests [myself]="myself" [currentLang]="currentLang">
        </app-user-settings-list-of-requests>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
